import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MetadataTagsApiActions, MetadataTagsUiActions } from '../actions';
import { catchError, map, mergeMap, of, tap } from 'rxjs';
import { ToastService } from '../../../../shared/services/toast.service';

import { MetadataTagsService } from '../../service/metadata-tags.service';
import { MetadataTagsFacade } from '../../facade/metadata-tags.facade';

@Injectable()
export class MetadataTagsEffects {
  private actions$ = inject(Actions);
  private toastService = inject(ToastService);
  private metadataTagsService = inject(MetadataTagsService);
  private metadataTagsFacade = inject(MetadataTagsFacade);

  constructor() {}
  getMetadataTags$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MetadataTagsUiActions.GetMetadataTags),
      mergeMap(() =>
        this.metadataTagsService.getMetadataTags().pipe(
          map((metadataTags) => {
            return MetadataTagsApiActions.getMetadataTagsSuccess({
              payload: Array.isArray(metadataTags) ? metadataTags : [metadataTags],
            });
          }),
          catchError((error) => {
            return of(MetadataTagsApiActions.getMetadataTagsError({ errors: error }));
          })
        )
      )
    )
  );
  postMetadataTags$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MetadataTagsUiActions.PostMetadataTags),
      mergeMap(({ metadataTag }) =>
        this.metadataTagsService.postMetadataTags(metadataTag).pipe(
          tap(() => {
            this.toastService.show(`Metadata tags saved successfully`, 'success');
          }),
          map(() => MetadataTagsApiActions.postMetadataTagsSuccess({ payload: metadataTag })),
          catchError((error) => {
            this.toastService.show(`Error saving metadata tags: ${error.message || 'Unexpected error'}`, 'error');
            return of(MetadataTagsApiActions.postMetadataTagsError({ errors: error }));
          })
        )
      )
    )
  );
  deleteMetadataTags$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MetadataTagsUiActions.DeleteMetadataTags),
      mergeMap(({ metadataTagId }) =>
        this.metadataTagsService.deleteMetadataTags(metadataTagId).pipe(
          tap(() => {
            this.toastService.show(`Metadata tags deleted successfully`, 'success');
          }),
          map(() => MetadataTagsApiActions.deleteMetadataTagsSuccess({ metadataTagId })),
          catchError((error) => {
            this.toastService.show(`Error deleting metadata tags: ${error.message || 'Unexpected error'}`, 'error');
            return of(MetadataTagsApiActions.deleteMetadataTagsError({ errors: error }));
          })
        )
      )
    )
  );
  deleteMetadataTagsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(MetadataTagsApiActions.deleteMetadataTagsSuccess),
        tap(() => {
          this.metadataTagsFacade.getMetadataTags();
        })
      ),
    { dispatch: false }
  );
  postMetadataTagsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(MetadataTagsApiActions.postMetadataTagsSuccess),
        tap(() => {
          this.metadataTagsFacade.getMetadataTags();
        })
      ),
    { dispatch: false }
  );
}
